import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';

import { DefaultCdmDeviceBehaviorPlugin } from './default-cdm.device-behavior';

export class AdtqCdmDeviceBehaviorPlugin extends DefaultCdmDeviceBehaviorPlugin {
	public override readonly models: DeviceModel[] = [DeviceModel.ADTQ];

	public hideWirelessMics(): boolean {
		return true;
	}

	public hideIdentifyAllButton(): boolean {
		return true;
	}
}
